import BatchPaymentsActionTypes from './batchPayments-types'

/*******************  Import Batch Payment File ********************* */
export const startImportBatchPaymentFile = data => ({
    type: BatchPaymentsActionTypes.START_IMPORT_BATCH_PAYMENT_FILE,
    payload: data,
})
export const successImportBatchPaymentFile = data => ({
    type: BatchPaymentsActionTypes.SUCCESS_IMPORT_BATCH_PAYMENT_FILE,
    payload: data,
})
export const finishImportBatchPaymentFile = data => ({
    type: BatchPaymentsActionTypes.FINISH_IMPORT_BATCH_PAYMENT_FILE,
    payload: data,
})
export const failureImportBatchPaymentFile = data => ({
    type: BatchPaymentsActionTypes.FAILURE_IMPORT_BATCH_PAYMENT_FILE,
    payload: data,
})

/*******************  Execute Batch Payment Requests ********************* */
export const startExecuteBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.START_EXECUTE_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const successExecuteBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.SUCCESS_EXECUTE_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const finishExecuteBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.FINISH_EXECUTE_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const failureExecuteBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.FAILURE_EXECUTE_BATCH_PAYMENT_REQUESTS,
    payload: data,
})

/*******************  Cancel Batch Payment Requests ********************* */
export const startCancelBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.START_CANCEL_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const successCancelBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.SUCCESS_CANCEL_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const finishCancelBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.FINISH_CANCEL_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const failureCancelBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.FAILURE_CANCEL_BATCH_PAYMENT_REQUESTS,
    payload: data,
})

/*******************  Fetch Batch Payment Statuses ********************* */
export const startGetBatchPaymentStatuses = data => ({
    type: BatchPaymentsActionTypes.START_GET_BATCH_PAYMENT_STATUSES,
    payload: data,
})
export const successGetBatchPaymentStatuses = data => ({
    type: BatchPaymentsActionTypes.SUCCESS_GET_BATCH_PAYMENT_STATUSES,
    payload: data,
})
export const finishGetBatchPaymentStatuses = data => ({
    type: BatchPaymentsActionTypes.FINISH_GET_BATCH_PAYMENT_STATUSES,
    payload: data,
})
export const failureGetBatchPaymentStatuses = data => ({
    type: BatchPaymentsActionTypes.FAILURE_GET_BATCH_PAYMENT_STATUSES,
    payload: data,
})

/*******************  Fetch All Imported Batch Payments ********************* */
export const startGetImportedBatchPayments = data => ({
    type: BatchPaymentsActionTypes.START_GET_IMPORTED_BATCH_PAYMENTS,
    payload: data,
})
export const successGetImportedBatchPayments = data => ({
    type: BatchPaymentsActionTypes.SUCCESS_GET_IMPORTED_BATCH_PAYMENTS,
    payload: data,
})
export const finishGetImportedBatchPayments = data => ({
    type: BatchPaymentsActionTypes.FINISH_GET_IMPORTED_BATCH_PAYMENTS,
    payload: data,
})
export const failureGetImportedBatchPayments = data => ({
    type: BatchPaymentsActionTypes.FAILURE_GET_IMPORTED_BATCH_PAYMENTS,
    payload: data,
})

/*******************  Fetch Single Imported Batch Payment ********************* */
export const startGetSingleImportedBatchPayment = data => ({
    type: BatchPaymentsActionTypes.START_GET_SINGLE_IMPORTED_BATCH_PAYMENT,
    payload: data,
})
export const successGetSingleImportedBatchPayment = data => ({
    type: BatchPaymentsActionTypes.SUCCESS_GET_SINGLE_IMPORTED_BATCH_PAYMENT,
    payload: data,
})
export const finishGetSingleImportedBatchPayment = data => ({
    type: BatchPaymentsActionTypes.FINISH_GET_SINGLE_IMPORTED_BATCH_PAYMENT,
    payload: data,
})
export const failureGetSingleImportedBatchPayment = data => ({
    type: BatchPaymentsActionTypes.FAILURE_GET_SINGLE_IMPORTED_BATCH_PAYMENT,
    payload: data,
})

/*******************  Fetch Selected Batch Payments Requests ********************* */
export const startGetBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.START_GET_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const successGetBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.SUCCESS_GET_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const finishGetBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.FINISH_GET_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
export const failureGetBatchPaymentRequests = data => ({
    type: BatchPaymentsActionTypes.FAILURE_GET_BATCH_PAYMENT_REQUESTS,
    payload: data,
})
